module.exports = __webpack_public_path__ + "img/ph_user-bold.a62bb8e2.svg";